var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "c-branch-reservation" }, [
    !_vm.isSuccess
      ? _c(
          "form",
          {
            ref: "formEl",
            staticClass: "c-branch-reservation__form",
            on: {
              submit: function ($event) {
                $event.preventDefault()
              },
              keydown: function ($event) {
                if (
                  !$event.type.indexOf("key") &&
                  _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")
                )
                  return null
                return _vm.onEnter.apply(null, arguments)
              },
            },
          },
          [
            _c(
              "div",
              { staticClass: "c-branch-reservation__main" },
              [_c("ReservationMain")],
              1
            ),
            _vm._v(" "),
            _c("div", { staticClass: "c-branch-reservation__footer" }, [
              _c("div", {
                staticClass: "sc-text",
                domProps: {
                  innerHTML: _vm._s(
                    _vm.selectedBranch
                      ? _vm.replaceTranslate(
                          _vm.$t("BranchReservation.Footer.infoText"),
                          "<strong>",
                          _vm.selectedBranch.custom_reservation_cutoff,
                          "</strong>"
                        )
                      : ""
                  ),
                },
              }),
              _vm._v(" "),
              _c("div", { staticClass: "sc-button" }, [
                _c("button", {
                  ref: "submitButton",
                  staticClass: "c-btn c-btn--cart",
                  class: {
                    "is-loading": _vm.isUpdating || _vm.isInitializing,
                  },
                  attrs: { disabled: _vm.isSubmitDisabled, type: "submit" },
                  domProps: {
                    innerHTML: _vm._s(
                      _vm.replaceTranslate(
                        _vm.$t("BranchReservation.Footer.submit"),
                        _vm.totals ? _vm.formatPrice(_vm.totals.price_vat) : "-"
                      )
                    ),
                  },
                }),
              ]),
            ]),
          ]
        )
      : _c(
          "div",
          { staticClass: "c-branch-reservation__success" },
          [_c("ReservationSuccess")],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }